module.exports = __webpack_public_path__ + "media/images/products/category/9-409db2f168df3aac1e649d9431f247f6.jpg";